import { render, staticRenderFns } from "./FooterShell.vue?vue&type=template&id=4e07a83f&scoped=true&"
import script from "./FooterShell.vue?vue&type=script&lang=js&"
export * from "./FooterShell.vue?vue&type=script&lang=js&"
import style0 from "./FooterShell.vue?vue&type=style&index=0&id=4e07a83f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e07a83f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VContainer,VIcon,VSheet})
